<template>
  <div class="roundBg">
    <h1 class="title-round is-size-2">{{ round.Title }}</h1>
    <div v-for="match in round.Matches" :key="match.Match" class="is-marginless match-box">
      <h1 class="title is-size-4">Match {{ match.Match }} 

            <span class="incomplete">
              <i class="fas fa-exclamation"></i> <span class="incomplete-text">incomplete</span>
            </span>

      </h1>
      <div class="winner-container">
        <ul>
            <li class="plyr"><i class="fas fa-user"></i> {{ (match.player1name != null ? match.player1name : getPlayerName(match.player1)) }} </li>
            <li class="plyr"><i class="fas fa-user"></i> {{ (match.player2name != null ? match.player2name : getPlayerName(match.player2)) }} </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'round',
  ],
    components : {
  },
  methods:{
    getPlayerName: function(playerId) {
      if (playerId != null && playerId != "" && playerId === "bye") {
        return "bye";
      } else {
        //console.log("getPlayerName: " + playerId);
        return this.$parent.$parent.gameData.finalPlayers[playerId-1].name;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .incomplete {
    color: rgb(255, 255, 125) !important;
    padding-left: 30px;
  }
  .incomplete-text {
    font-size: 0.50m;
    font-weight: normal;
  }
  .plyr {
    color: yellow;
  }
  .locked {
    color: yellow;
  }
  .winner {
    color: gold;
  }
  .loser {
    color: gray;
  }
  .winner-name {
    color: green;
  }
  .winner-container {
    padding: 20px;
    background-color: rgb(36, 36, 39);
  }
  .expand-icon {
    color: yellow;
  }
  .match-box {
    border: solid yellow 1px;
    border-radius: 5px !important;
    margin-bottom: 10px !important;
  }
  .title {
    border-bottom: solid yellow 1px;
    font-family: '28 Days Later';
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    color: green !important;
    cursor: pointer;
    margin-bottom: 0px;
    background-color: rgb(36, 36, 39);
  }
  .title-round {
    font-family: '28 Days Later';
    padding-left: 20px;
    padding-top: 20px;
    color: red !important;
  }
  .roundBg {
    padding-left: 0px;
    padding-right: 0px;
  }
</style>